<trial-success-page>
  <!-- Container with gradient background -->
  <div if="{locale}" class="min-h-screen flex items-center justify-center p-5">
    <!-- Success card -->
    <div class="card w-full max-w-2xl animate-fade-in-up">
      <div class="card-body p-10">
        <!-- Brand logo -->
        <div class="text-center mb-6">
          <img src="./Lark.png" alt="MetaLark.ai" class="h-16 mx-auto" />
        </div>

        <!-- Title and message -->
        <div class="brand-header">
          <h1 class="text-3xl font-bold text-center brand-title mb-3">
            {locale?.t('trialsuccess_welcome')}
          </h1>
          <p class="brand-tagline text-center font-medium text-lg">{locale?.t('trialsuccess_tagline')}</p>
        </div>

        <h2 class="text-[22px] font-bold text-center text-accent mb-3">
          {locale?.t('trialsuccess_title')}
        </h2>
        <p class="text-center font-medium text-lg mb-8">
          {locale?.t('trialsuccess_message')}
        </p>

        <!-- Success icon with animation -->
        <div class="flex justify-center mb-6">
          <div class="w-20 h-20 rounded-full bg-gradient-to-br from-green-400 to-green-600 flex items-center justify-center text-5xl text-white animate-scale-in">
            ✓
          </div>
        </div>

        <!-- What's Next section -->
        <div class="bg-[#f3f4f6] rounded-lg p-6 mb-6">
          <h3 class="text-xl font-semibold text-primary text-center mb-4">
            {locale?.t('trialsuccess_whatsnext')}
          </h3>
          <ol class="space-y-5">
            <li class="flex gap-3">
              <div class="flex-shrink-0">
                <div class="w-7 h-7 rounded-full bg-accent text-white flex items-center justify-center text-sm font-semibold">
                  1
                </div>
              </div>
              <div class="flex-1">
                <strong class="text-accent block text-lg mb-1">{locale?.t('trialsuccess_step1_title')}</strong>
                <span class="text-lg">({state.email})</span>
                <p class="text-lg mt-1 font-medium">
                  {locale?.t('trialsuccess_step1_message')}
                </p>
              </div>
            </li>
            <li class="flex gap-3">
              <div class="flex-shrink-0">
                <div class="w-7 h-7 rounded-full bg-accent text-white flex items-center justify-center text-sm font-semibold">
                  2
                </div>
              </div>
              <div class="flex-1">
                <strong class="text-accent block text-lg mb-1">{locale?.t('trialsuccess_step2_title')}</strong>
                <p class="text-lg font-medium">
                  {locale?.t('trialsuccess_step2_message')}
                </p>
              </div>
            </li>
            <li class="flex gap-3">
              <div class="flex-shrink-0">
                <div class="w-7 h-7 rounded-full bg-accent text-white flex items-center justify-center text-lg font-semibold">
                  3
                </div>
              </div>
              <div class="flex-1">
                <strong class="text-accent text-lg block mb-1">{locale?.t('trialsuccess_step3_title')}</strong>
                <p class="text-lg font-medium">
                  {locale?.t('trialsuccess_step3_message', { trialCredits: state.trialCredits })}
                </p>
              </div>
            </li>
          </ol>
        </div>

        <!-- Trial details section -->
        <div class="bg-[#eff6ff] border border-[#dbeafe] rounded-lg p-6 mb-6">
          <h3 class="text-lg font-semibold text-primary text-center mb-4">
            {locale?.t('trialsuccess_trialincludes')}
          </h3>
          <div class="space-y-4">
            <div class="flex items-start gap-3">
              <span class="text-[32px] flex-shrink-0">📅</span>
              <div class="flex-1">
                <strong class="text-accent block text-base">
                  {locale?.t('trialsuccess_daysfree', { days: state.trialDays })}
                </strong>
                <p class="font-medium text-md">
                  {locale?.t('trialsuccess_secureinstance')}
                </p>
              </div>
            </div>
            <div class="flex items-start gap-3">
              <span class="text-[32px] flex-shrink-0">⚡</span>
              <div class="flex-1">
                <strong class="text-accent block text-base">
                  {locale?.t(state.isPaidTrial ? 'trialsuccess_credits' : 'trialsuccess_freecredits', { credits: state.trialCredits })}
                </strong>
                <p class="font-medium text-md">
                  {locale?.t('trialsuccess_processcontent')}
                </p>
              </div>
            </div>
            <div class="flex items-start gap-3" if={!state.isPaidTrial}>
              <span class="text-[32px] flex-shrink-0">💳</span>
              <div class="flex-1">
                <strong class="text-accent block text-base">
                  {locale?.t('trialsuccess_nocreditcard')}
                </strong>
                <p class="font-medium text-md">
                  {locale?.t('trialsuccess_nopayment')}
                </p>
              </div>
            </div>
          </div>
        </div>

        <!-- Action buttons -->
        <div class="flex flex-col sm:flex-row gap-3 mb-4">
          <a
            href="#/login"
            class="flex-1 px-6 py-3 bg-[#6b7ba8] text-white rounded-lg font-medium text-center transition-all duration-200 hover:bg-[#6b7ba8] hover:-translate-y-0.5 hover:shadow-[0_4px_12px_rgba(102,126,234,0.4)]"
          >
            {locale?.t('trialsuccess_gotologin')}
          </a>
          <button
            onclick={resendEmail}
            class="flex-1 px-6 py-3 border border-primary bg-[#ffffff] text-[#6b7ba8] rounded-lg font-medium transition-all duration-200 hover:bg-[#ffffff] hover:-translate-y-0.5 hover:shadow-[0_4px_12px_rgba(102,126,234,0.4)] disabled:opacity-60 disabled:cursor-not-allowed"
            disabled={state.resending}
          >
            {state.resending ? locale?.t('trialsuccess_sending') : locale?.t('trialsuccess_resendverification')}
          </button>
        </div>

        <!-- Success alert -->
        <div if={state.resendSuccess} class="alert alert-success">
          <svg xmlns="http://www.w3.org/2000/svg" class="stroke-current shrink-0 h-6 w-6" fill="none" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <span>{locale?.t('trialsuccess_emailsent')}</span>
        </div>

        <!-- Error alert -->
        <div if={state.resendError} class="alert alert-error">
          <svg xmlns="http://www.w3.org/2000/svg" class="stroke-current shrink-0 h-6 w-6" fill="none" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <span>{state.resendError}</span>
        </div>

        <!-- Footer note -->
        <div class="text-center mt-6 pt-6 border-t border-gray-200">
          <p class="text-gray-600 text-sm">
            {locale?.t('trialsuccess_notreceived')}
            <a href="mailto:support@metalark.ai" class="link link-primary">{locale?.t('trialsuccess_contactsupport')}</a>.
          </p>
        </div>
      </div>
    </div>
  </div>

  <style>
    /* Custom animations */
    @keyframes fade-in-up {
      from {
        opacity: 0;
        transform: translateY(20px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }

    @keyframes scale-in {
      from {
        transform: scale(0);
      }
      to {
        transform: scale(1);
      }
    }

    .animate-fade-in-up {
      animation: fade-in-up 0.4s ease-out;
    }

    .animate-scale-in {
      animation: scale-in 0.5s ease-out 0.2s both;
    }

    .brand-title {
      color: var(--color-accent);
      font-size: 28px;
      font-weight: 700;
      margin-bottom: 8px;
    }

    .brand-header {
      margin-bottom: 32px;
      padding-bottom: 24px;
      border-bottom: 1px solid #e5e7eb;
    }

    .brand-tagline {
      /*color: #6b7280;*/
      /*font-size: 14px;*/
      /*font-weight: 500;*/
      /*margin: 0;*/
      /*letter-spacing: 0.5px;*/
    }
  </style>

  <script>
    import { getApi } from '../services/service-loader'

    export default {
      includeTools: false,

      state: {
        email: '',
        resending: false,
        resendSuccess: false,
        resendError: '',
        trialDays: 30,
        trialCredits: 20,
        isPaidTrial: false
      },

      async onMounted() {
        // Get parameters from URL
        const urlParams = new URLSearchParams(window.location.hash.split('?')[1])
        let email = urlParams.get('email')
        const source = urlParams.get('source')
        const paid = urlParams.get('paid')
        const checkoutId = urlParams.get('checkoutId')
        
        // Determine if this is a paid trial (from Stripe) or free trial (direct signup)
        const isPaidTrial = source === 'stripe' || paid === 'true'
        
        // If we have a checkoutId but no email, fetch the email from Stripe
        if (checkoutId && !email) {
          try {
            const api = await getApi()
            const response = await api.get(`/stripe/checkout-session?sessionId=${encodeURIComponent(checkoutId)}`)
            if (response.data && response.data.email) {
              email = response.data.email
              console.log('Retrieved email from checkout session:', email)
            }
          } catch (error) {
            console.error('Failed to fetch email from checkout session:', error)
            // Continue with 'your email' as fallback
          }
        }
        
        if (email) {
          this.update({
            email: decodeURIComponent(email),
            isPaidTrial
          })
        } else {
          this.update({
            email: 'your email',
            isPaidTrial
          })
        }

        // Fetch current trial configuration
        try {
          const api = await getApi()
          const response = await api.get('/trial/config')
          if (response.data) {
            this.update({
              trialDays: response.data.durationDays,
              trialCredits: response.data.credits
            })
          }
        } catch (error) {
          console.error('Failed to load trial config:', error)
          // Continue with default values
        }
      },

      async resendEmail() {
        if (!this.state.email || this.state.email === 'your email') {
          this.update({ 
            resendError: 'Email address not found. Please try signing up again.' 
          })
          return
        }

        this.update({ 
          resending: true, 
          resendSuccess: false, 
          resendError: '' 
        })

        try {
          const api = await getApi()
          const response = await api.post('/email/resend-verification', {
            email: this.state.email
          })

          if (response.data.success) {
            this.update({
              resending: false,
              resendSuccess: true,
              resendError: ''
            })

            // Clear success message after 5 seconds
            setTimeout(() => {
              this.update({ resendSuccess: false })
            }, 5000)
          } else {
            this.update({
              resending: false,
              resendError: response.data.message || 'Failed to resend email'
            })
          }
        } catch (error) {
          console.error('Resend error:', error)
          this.update({
            resending: false,
            resendError: error.response?.data?.message || 'Failed to resend verification email'
          })
        }
      }
    }
  </script>
</trial-success-page>